/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum DeviceStatus {
    NoStatus = 'NO_STATUS',
    Pending = 'PENDING',
    Postponed = 'POSTPONED',
    UpToDate = 'UP_TO_DATE'
}

export function DeviceStatusFromJSON(json: any): DeviceStatus {
    return DeviceStatusFromJSONTyped(json, false);
}

export function DeviceStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceStatus {
    return json as DeviceStatus;
}

export function DeviceStatusToJSON(value?: DeviceStatus | null): any {
    return value as any;
}

